
// const trackBasket = useSelector((state) => state.track);
//   let trackOrd = trackBasket.track;
const HandleTracking = (status) => {
    let res = "";

    switch (status) {
        case 0:
            res = "Pending"
            break;
        case 1:
            res = "We are in Market"
            break;
        case 2:
            res = "Packaging"
            break;
        case 3:
            res = "On Transit"
            break;
        case 4:
            res = "Ready to be Picked"
            break;
        case 5:
            res = "Delivered"
            break;
        case 6:
            res = "Treated"
            break;

        default:
            break;
    }
    return res;

}
export default HandleTracking;
